/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiTestsIdDelete$Params {
  id: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiTestsIdDelete(http: HttpClient, rootUrl: string, params: ApiTestsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTestsIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiTestsIdDelete.PATH = '/api/Tests/{id}';
